export default __webpack_public_path__ + "static/media/element_92.1149ea37.webp";